








































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { ISignUpFields, ICognitoSignUpFields } from '@/common/types';

// components
import Base from '@/components/Login/Base.vue';
import Welcome from '@/components/Global/Welcome.vue';
import Validation from '@/components/Form/Validation.vue';
import TextField from '@/components/Form/TextField.vue';
import Alert from '@/components/Global/Alert.vue';
import SelectField from '@/components/Form/SelectField.vue';
import RadioField from '@/components/Form/RadioField.vue';
import Checkbox from '@/components/Form/Checkbox.vue';
import Card from '@/components/Global/Card.vue';
// Services
import router from '../../router';
import Brand from '@/services/Brand';
import store from '@/store';
import AuthService from '@/services/Auth';
import ProgressTrackerDesktop from './ProgressTracker.vue';
import { Features } from '@/services/Features';

// validations
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators';
import { helpers } from 'vuelidate/lib/validators';
import { hasUppercase, hasLowercase, hasNumber, hasSpecialCharacter } from '@/validations';
import { IUserCapabilities } from '@/common/Auth';

// Declare permissions as a strict subset of `IUserCapabilities` by using only the keys that have
// a checkbox controlling them.
type PermissionKey =
	| 'BILL_PAY'
	| 'VIEW_CLAIMS'
	| 'VIEW_COI'
	| 'VIEW_POLICY_INFO'
	| 'VIEW_REPORTS'
	| 'VIEW_RISK_MANAGEMENT';
type Permissions = Pick<IUserCapabilities, PermissionKey>;

@Component({
	name: 'QuickQuestions',
	components: {
		Alert,
		Base,
		Card,
		Checkbox,
		ProgressTrackerDesktop,
		RadioField,
		SelectField,
		TextField,
		Validation,
		Welcome,
	},
	validations: {
		form: {
			policyNum: {
				required,
			},
			regKey: {
				required,
			},
		},
	},
})
export default class QuickQuestions extends Vue {
	private readonly Brand = Brand;

	private readonly form = {
		policyNum: '',
		regKey: '',
	};
	private isAgentBroker: 'yes' | 'no' | '' = '';
	private logger: any = {};
	private readonly permissions: Permissions = {
		BILL_PAY: false,
		VIEW_POLICY_INFO: false,
		VIEW_CLAIMS: false,
		VIEW_REPORTS: false,
		VIEW_RISK_MANAGEMENT: false,
		VIEW_COI: false,
	};

	private mounted() {
		window.newUserRegistered = false;
	}

	private get showCoiCheckbox(): boolean {
		const brand: string = Brand.getBrand();
		return brand === 'umia' && !Features.isUmiaPolicyDocumentsEnabled;
	}

	private get showPolicyDocumentsCheckbox(): boolean {
		const brand: string = Brand.getBrand();
		return (
			brand === 'amic' ||
			brand === 'mmic' ||
			(brand === 'umia' && Features.isUmiaPolicyDocumentsEnabled)
		);
	}

	private get showReportsCheckbox(): boolean {
		const brand: string = Brand.getBrand();
		return brand === 'mmic' || (brand === 'umia' && Features.isUmiaPolicyDocumentsEnabled);
	}

	private get showPolicyInfoCard(): boolean {
		return (
			this.permissions.BILL_PAY ||
			this.permissions.VIEW_CLAIMS ||
			this.permissions.VIEW_COI ||
			this.permissions.VIEW_POLICY_INFO ||
			this.permissions.VIEW_REPORTS
		);
	}

	private get showReportsWarning(): boolean {
		return this.showReportsCheckbox && this.permissions.VIEW_REPORTS;
	}

	private get showRiskResourcesWarning(): boolean {
		return this.isOnlyRiskResourcesSelected();
	}

	private goToAccountSetup(): void {
		if (this.permissions.VIEW_REPORTS) {
			this.$store.dispatch('Registration/setupReportsRequested', true);
		}
		if (this.isOnlyRiskResourcesSelected()) {
			this.$store.dispatch('Registration/setupRiskResourcesRequested', true);
		}
		if (this.form.policyNum) {
			this.$store.dispatch(
				'Registration/setupPolicyNum',
				this.form.policyNum.trim().toUpperCase(),
			);
		}
		if (this.form.regKey) {
			this.$store.dispatch(
				'Registration/setupClientId',
				this.form.regKey.trim().toUpperCase(),
			);
		}

		// Expand out some implied capabilities.
		const capabilities: Partial<IUserCapabilities> = {
			...this.permissions,
			PAYMENT_HISTORY: this.permissions.BILL_PAY,
			REPORT_CLAIM: this.permissions.VIEW_CLAIMS,
		};
		this.$store.dispatch('Registration/setupPermissions', capabilities);

		this.$router.push({
			name: 'account-setup',
			params: {
				quickQuestions: true,
			},
		});
	}

	private isInvalid(): boolean {
		if (
			!this.permissions.BILL_PAY &&
			!this.permissions.VIEW_CLAIMS &&
			!this.permissions.VIEW_COI &&
			!this.permissions.VIEW_POLICY_INFO &&
			!this.permissions.VIEW_REPORTS &&
			this.permissions.VIEW_RISK_MANAGEMENT
		) {
			return false;
		}
		return this.$v.$invalid;
	}

	private isOnlyRiskResourcesSelected(): boolean {
		return (
			!this.permissions.BILL_PAY &&
			!this.permissions.VIEW_CLAIMS &&
			!this.permissions.VIEW_COI &&
			!this.permissions.VIEW_POLICY_INFO &&
			!this.permissions.VIEW_REPORTS &&
			this.permissions.VIEW_RISK_MANAGEMENT
		);
	}
}
